import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Account, AuthenticationError } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  hasSession: boolean;
  hasRetrievedSession: boolean;
  error: AuthenticationError;
  account: Account;
  authenticate(credentials: Boundaries["authenticate"]["request"]): void;
}

function useAuthentication(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isAuthenticationRequestPending),
    isRequestSuccess: useSelector(selector.isAuthenticationRequestSuccess),
    isRequestFailure: useSelector(selector.isAuthenticationRequestFailure),
    account: useSelector(selector.getAccount),
    hasSession: useSelector(selector.hasSession),
    hasRetrievedSession: useSelector(selector.hasRetrievedSession),
    error: useSelector(selector.getAuthenticationError),
    authenticate: core.authenticate,
  };
}

export { useAuthentication };
